(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OpenviewNotification", [], factory);
	else if(typeof exports === 'object')
		exports["OpenviewNotification"] = factory();
	else
		root["OpenviewNotification"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TsDom = /** @class */ (function () {
    /**
     * Initialize selector
     *
     * @param {any | string} selector
     * @param {HTMLElement | Document} context
     */
    function TsDom(selector, context) {
        // Nodes collection array
        this.nodes = [];
        /**
         * Pseudo selector for current node
         *
         * @type {string}
         */
        this.pseudoSelector = '';
        this.callbacks = {};
        if (!context) {
            context = document;
        }
        if (typeof selector === 'string') {
            if (selector[0] === '<' && selector[selector.length - 1] === ">") {
                this.nodes = [TsDom.createNode(selector)];
            }
            else {
                if (selector.search(/(:before|:after)$/gi) !== -1) {
                    var found = selector.match(/(:before|:after)$/gi);
                    selector = selector.split(found[0])[0];
                    this.pseudoSelector = found[0];
                }
                // Query DOM
                this.nodes = [].slice.call(context.querySelectorAll(selector));
            }
        }
        else if (selector instanceof NodeList) {
            this.nodes = selector.length > 1 ? [].slice.call(selector) : [selector];
        }
        else if (selector instanceof HTMLDocument || selector instanceof Window || selector instanceof HTMLElement) {
            this.nodes = [selector];
        }
    }
    TsDom.select = function (selector, context) {
        return new TsDom(selector, context);
    };
    TsDom.create = function (nodeName) {
        return new TsDom(TsDom.createNode(nodeName));
    };
    TsDom.prototype.attr = function (attrName, attrValue) {
        if (attrValue != undefined) {
            this.each(this.nodes, function (node) {
                node.setAttribute(attrName, attrValue);
            });
            return this;
        }
        return this.getLastNode().getAttribute(attrName);
    };
    /**
     * Append content to nodes
     *
     * @param {HTMLElement} content
     */
    TsDom.prototype.append = function (content) {
        var element;
        if (content instanceof TsDom) {
            element = content.get();
        }
        else {
            element = content;
        }
        this.each(this.nodes, function (node) {
            node.appendChild(element);
        });
        return this;
    };
    TsDom.prototype.parent = function () {
        return new TsDom(this.getLastNode().parentNode);
    };
    /**
     * Iteration per elements
     *
     * @param {HTMLElement[]} nodes
     * @param {Function} callback
     * @returns {TsDom}
     */
    TsDom.prototype.each = function (nodes, callback) {
        if (nodes instanceof Function) {
            callback = nodes;
            nodes = this.nodes;
        }
        for (var i = 0; i < nodes.length; i++) {
            callback.call(this.nodes[i], this.nodes[i], i);
        }
        return this;
    };
    TsDom.prototype.hasClass = function (className) {
        return this.getLastNode().classList.contains(className);
    };
    /**
     * Add css classes to element
     *
     * @param {string} className
     * @returns {TsDom}
     */
    TsDom.prototype.addClass = function (className) {
        if (className) {
            var cssClasses_1 = className.split(' ');
            this.each(this.nodes, function (node) {
                for (var classIndex in cssClasses_1) {
                    node.classList.add(cssClasses_1[classIndex]);
                }
            });
        }
        return this;
    };
    /**
     * Remove css classes from element
     *
     * @param {string} className
     * @returns {TsDom}
     */
    TsDom.prototype.removeClass = function (className) {
        var cssClasses = className.split(' ');
        this.each(this.nodes, function (node) {
            for (var classIndex in cssClasses) {
                node.classList.remove(cssClasses[classIndex]);
            }
        });
        return this;
    };
    TsDom.prototype.find = function (selector) {
        return new TsDom(selector, this.getLastNode());
    };
    TsDom.prototype.trigger = function (eventName, detail) {
        var event = new CustomEvent(eventName, {
            detail: detail
        });
        this.each(this.nodes, function (node) {
            node.dispatchEvent(event);
        });
        return this;
    };
    TsDom.prototype.text = function (text) {
        this.each(this.nodes, function (node) {
            node.innerText = text;
        });
        return this;
    };
    /**
     * Set ot Get css property from element
     *
     * @param styleName
     * @param value
     * @returns {any}
     */
    TsDom.prototype.css = function (styleName, value) {
        if (typeof value == 'undefined') {
            var node = this.getLastNode();
            var result = null;
            styleName = TsDom.convertToJsProperty(styleName);
            if ((typeof node.getBoundingClientRect === "function") && !this.pseudoSelector) {
                result = node.getBoundingClientRect()[styleName];
            }
            if (!result) {
                var value_1 = getComputedStyle(node, this.pseudoSelector)[styleName];
                if (value_1.search('px')) {
                    result = parseInt(value_1, 10);
                }
            }
            if (isNaN(result)) {
                throw 'Undefined css property: ' + styleName;
            }
            return result;
        }
        else {
            if (Number.isInteger(value)) {
                value = value + 'px';
            }
            if (this.nodes.length > 1) {
                this.each(this.nodes, function (node) {
                    node.style[styleName] = value;
                });
            }
            else {
                this.nodes[0].style[styleName] = value;
            }
        }
        return this;
    };
    /**
     * Add event listener to element
     *
     * @param {string} eventName
     * @param {Function} callback
     * @returns {TsDom}
     */
    TsDom.prototype.on = function (eventName, callback) {
        var _this = this;
        this.each(this.nodes, function (node) {
            var callbackFn = function (e) {
                callback.call(node, e);
            };
            _this.callbacks[eventName] = callbackFn;
            node.addEventListener(eventName, callbackFn);
        });
        return this;
    };
    TsDom.prototype.off = function (eventName) {
        var callbackFn = this.callbacks[eventName];
        this.each(this.nodes, function (node) {
            node.removeEventListener(eventName, callbackFn, false);
        });
        return this;
    };
    TsDom.prototype.val = function (value) {
        if (typeof value === 'undefined') {
            return this.getLastNode().value;
        }
        this.each(this.nodes, function (node) {
            node.value = value;
        });
        return this;
    };
    /**
     * Check node type
     *
     * @param {string} tagName
     * @returns {boolean}
     */
    TsDom.prototype.is = function (tagName) {
        return this.getLastNode().tagName.toLowerCase() === tagName;
    };
    TsDom.prototype.get = function (index) {
        if (index === void 0) { index = 0; }
        return this.nodes[index];
    };
    TsDom.prototype.length = function () {
        return this.nodes.length;
    };
    TsDom.prototype.hide = function () {
        this.each(this.nodes, function (node) {
            TsDom.select(node).css('display', 'none');
        });
        return this;
    };
    TsDom.prototype.show = function () {
        this.each(this.nodes, function (node) {
            TsDom.select(node).css('display', '');
        });
        return this;
    };
    TsDom.prototype.empty = function () {
        this.each(this.nodes, function (node) {
            TsDom.select(node).get().innerHTML = '';
        });
        return this;
    };
    TsDom.prototype.html = function (content) {
        this.each(this.nodes, function (node) {
            node.innerHTML = content;
        });
    };
    TsDom.prototype.remove = function () {
        this.each(this.nodes, function (node) {
            node.remove();
        });
    };
    TsDom.prototype.insertBefore = function (data) {
        var element = this.resolveElement(data);
        this.each(this.nodes, function (node) {
            node.parentNode.insertBefore(element, element.previousSibling);
        });
        return this;
    };
    TsDom.prototype.insertAfter = function (contents) {
        var element = this.resolveElement(contents);
        this.each(this.nodes, function (node) {
            node.parentNode.insertBefore(element, node.nextSibling);
        });
        return this;
    };
    TsDom.prototype.resolveElement = function (contents) {
        var element;
        if (TsDom.isHtml(contents)) {
            element = TsDom.createNode(contents);
        }
        else if (contents instanceof HTMLElement) {
            element = contents;
        }
        else if (contents instanceof TsDom) {
            element = contents.get();
        }
        return element;
    };
    TsDom.prototype.closest = function (selector) {
        return TsDom.select(this.getLastNode().closest(selector));
    };
    TsDom.prototype.data = function (dataName) {
        return this.attr('data-' + dataName);
    };
    TsDom.prototype.width = function (value) {
        if (value !== undefined) {
            this.css('width', value);
            return this;
        }
        if (this.getLastNode() === window) {
            return parseInt(this.getLastNode().innerWidth, 10);
        }
        return parseInt(this.css('width'), 10);
    };
    TsDom.prototype.height = function (value) {
        if (value !== undefined) {
            this.css('height', value);
            return this;
        }
        if (this.getLastNode() === window) {
            return parseInt(this.getLastNode().innerHeight, 10);
        }
        return parseInt(this.css('height'), 10);
    };
    TsDom.prototype.position = function () {
        return {
            top: Number(this.getLastNode().getBoundingClientRect().top),
            bottom: Number(this.getLastNode().getBoundingClientRect().bottom),
            left: Number(this.getLastNode().getBoundingClientRect().left),
            right: Number(this.getLastNode().getBoundingClientRect().right),
        };
    };
    TsDom.prototype.offset = function () {
        return {
            top: Number(this.getLastNode().offsetTop),
            left: Number(this.getLastNode().offsetLeft)
        };
    };
    TsDom.createNode = function (nodeName) {
        if (nodeName[0] === '<' && nodeName[nodeName.length - 1] === ">") {
            var element = document.createElement('div');
            element.innerHTML = nodeName;
            return element.firstChild;
        }
        else {
            return document.createElement(nodeName);
        }
    };
    TsDom.isHtml = function (text) {
        return text[0] === '<' && text[text.length - 1] === ">";
    };
    /**
     * Make css property notation to javascript property notation
     *
     * @param {string} propertyName
     * @returns {string}
     */
    TsDom.convertToJsProperty = function (propertyName) {
        propertyName = propertyName.toLowerCase().replace('-', ' ');
        propertyName = propertyName.replace(/(^| )(\w)/g, function (x) {
            return x.toUpperCase();
        });
        propertyName = propertyName.charAt(0).toLowerCase() + propertyName.slice(1);
        return propertyName.replace(' ', '');
    };
    /**
     *
     * @returns {any}
     */
    TsDom.prototype.getLastNode = function () {
        return this.nodes[this.nodes.length - 1];
    };
    return TsDom;
}());
exports.default = TsDom;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tsdom_1 = __webpack_require__(0);
var TopRightPosition = /** @class */ (function () {
    function TopRightPosition(notification, margin) {
        this.notification = notification;
        this.margin = margin;
    }
    TopRightPosition.prototype.calculate = function () {
        var _this = this;
        var offset = this.margin, notifications = tsdom_1.default.select('.openview-notification.position-' + TopRightPosition.position);
        notifications.each(function (el) {
            tsdom_1.default.select(el)
                .css('top', offset)
                .css('right', _this.margin);
            offset += tsdom_1.default.select(el).height() + _this.margin;
        });
    };
    TopRightPosition.prototype.instances = function () {
        var result = [], notifications = tsdom_1.default.select('.openview-notification.position-' + TopRightPosition.position);
        notifications.each(function (notification) {
            result.push(tsdom_1.default.select(notification));
        });
        return result;
    };
    TopRightPosition.position = 'top-right';
    return TopRightPosition;
}());
exports.TopRightPosition = TopRightPosition;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tsdom_1 = __webpack_require__(0);
var TopCenterPosition = /** @class */ (function () {
    function TopCenterPosition(notification, margin) {
        this.notification = notification;
        this.margin = margin;
    }
    TopCenterPosition.prototype.calculate = function () {
        var _this = this;
        var offset = this.margin, notifications = tsdom_1.default.select('.openview-notification.position-' + TopCenterPosition.position);
        notifications.each(function (el) {
            var element = tsdom_1.default.select(el);
            element
                .css('top', offset)
                .css('left', 'calc(50% - ' + (Math.ceil(element.width() / 2)) + 'px)');
            offset += element.height() + _this.margin;
        });
    };
    TopCenterPosition.prototype.instances = function () {
        var result = [], notifications = tsdom_1.default.select('.openview-notification.position-' + TopCenterPosition.position);
        notifications.each(function (notification) {
            result.push(tsdom_1.default.select(notification));
        });
        return result;
    };
    TopCenterPosition.position = 'top-center';
    return TopCenterPosition;
}());
exports.TopCenterPosition = TopCenterPosition;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tsdom_1 = __webpack_require__(0);
var BottomRightPosition = /** @class */ (function () {
    function BottomRightPosition(notification, margin) {
        this.notification = notification;
        this.margin = margin;
    }
    BottomRightPosition.prototype.calculate = function () {
        var _this = this;
        var offset = this.margin, notifications = tsdom_1.default.select('.openview-notification.position-' + BottomRightPosition.position);
        notifications.each(function (el) {
            var element = tsdom_1.default.select(el);
            element
                .css('bottom', offset)
                .css('right', _this.margin);
            offset += element.height() + _this.margin;
        });
    };
    BottomRightPosition.prototype.instances = function () {
        var result = [], notifications = tsdom_1.default.select('.openview-notification.position-' + BottomRightPosition.position);
        notifications.each(function (notification) {
            result.push(tsdom_1.default.select(notification));
        });
        return result;
    };
    BottomRightPosition.position = 'bottom-right';
    return BottomRightPosition;
}());
exports.BottomRightPosition = BottomRightPosition;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tsdom_1 = __webpack_require__(0);
var TopLeftPosition = /** @class */ (function () {
    function TopLeftPosition(notification, margin) {
        this.notification = notification;
        this.margin = margin;
    }
    TopLeftPosition.prototype.calculate = function () {
        var _this = this;
        var offset = this.margin;
        var notifications = tsdom_1.default.select('.openview-notification.position-' + TopLeftPosition.position);
        notifications.each(function (el) {
            var element = tsdom_1.default.select(el);
            element
                .css('top', offset)
                .css('left', _this.margin);
            offset += element.height() + _this.margin;
        });
    };
    TopLeftPosition.prototype.instances = function () {
        var result = [], notifications = tsdom_1.default.select('.openview-notification.position-' + TopLeftPosition.position);
        notifications.each(function (notification) {
            result.push(tsdom_1.default.select(notification));
        });
        return result;
    };
    TopLeftPosition.position = 'top-left';
    return TopLeftPosition;
}());
exports.TopLeftPosition = TopLeftPosition;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tsdom_1 = __webpack_require__(0);
var BottomCenterPosition = /** @class */ (function () {
    function BottomCenterPosition(notification, margin) {
        this.notification = notification;
        this.margin = margin;
    }
    BottomCenterPosition.prototype.calculate = function () {
        var _this = this;
        var offset = this.margin, notifications = tsdom_1.default.select('.openview-notification.position-' + BottomCenterPosition.position);
        notifications.each(function (el) {
            var element = tsdom_1.default.select(el);
            element
                .css('bottom', offset)
                .css('left', 'calc(50% - ' + (Math.ceil(element.width() / 2)) + 'px)');
            offset += element.height() + _this.margin;
        });
    };
    BottomCenterPosition.prototype.instances = function () {
        var result = [], notifications = tsdom_1.default.select('.openview-notification.position-' + BottomCenterPosition.position);
        notifications.each(function (notification) {
            result.push(tsdom_1.default.select(notification));
        });
        return result;
    };
    BottomCenterPosition.position = 'bottom-center';
    return BottomCenterPosition;
}());
exports.BottomCenterPosition = BottomCenterPosition;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tsdom_1 = __webpack_require__(0);
var BottomLeftPosition = /** @class */ (function () {
    function BottomLeftPosition(notification, margin) {
        this.notification = notification;
        this.margin = margin;
    }
    BottomLeftPosition.prototype.calculate = function () {
        var _this = this;
        var offset = this.margin, notifications = tsdom_1.default.select('.openview-notification.position-' + BottomLeftPosition.position);
        notifications.each(function (el) {
            var element = tsdom_1.default.select(el);
            element
                .css('bottom', offset)
                .css('left', _this.margin);
            offset += element.height() + _this.margin;
        });
    };
    BottomLeftPosition.prototype.instances = function () {
        var result = [], notifications = tsdom_1.default.select('.openview-notification.position-' + BottomLeftPosition.position);
        notifications.each(function (notification) {
            result.push(tsdom_1.default.select(notification));
        });
        return result;
    };
    BottomLeftPosition.position = 'bottom-left';
    return BottomLeftPosition;
}());
exports.BottomLeftPosition = BottomLeftPosition;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(10);
__webpack_require__(15);
__webpack_require__(17);
var PositionFactory_1 = __webpack_require__(8);
var deepmerge = __webpack_require__(9);
var tsdom_1 = __webpack_require__(0);
var TopCenterPosition_1 = __webpack_require__(2);
var TopRightPosition_1 = __webpack_require__(1);
var TopLeftPosition_1 = __webpack_require__(4);
var BottomCenterPosition_1 = __webpack_require__(5);
var BottomLeftPosition_1 = __webpack_require__(6);
var BottomRightPosition_1 = __webpack_require__(3);
var OpenviewNotification = /** @class */ (function () {
    function OpenviewNotification(options) {
        if (options === void 0) { options = {}; }
        this.options = deepmerge.all([OpenviewNotification.defaultOptions, OpenviewNotification.globalOptions, options]);
        // Disable animation duration if animation close set to 'none'
        if (!this.options.animation.close || this.options.animation.close == 'none') {
            this.options.animationDuration = 0;
        }
        this.notification = tsdom_1.default.create('div');
        this.body = tsdom_1.default.select('body');
        this.template = OpenviewNotification.template;
        this.position = PositionFactory_1.PositionFactory.newInstance(this.options.position, this.notification, this.options.margin);
        OpenviewNotification.instances.push(this);
    }
    Object.defineProperty(OpenviewNotification, "defaultOptions", {
        get: function () {
            return {
                margin: 20,
                type: 'default',
                title: '',
                description: '',
                image: {
                    visible: false,
                    customImage: ''
                },
                closeTimeout: 0,
                closeWith: [],
                animation: {
                    open: 'slide-in',
                    close: 'slide-out'
                },
                animationDuration: .2,
                position: 'top-right',
                showBorder: false,
                showButtons: false,
                buttons: {
                    action: {
                        text: 'Ok',
                        callback: function () { }
                    },
                    cancel: {
                        text: 'Cancel',
                        callback: function () { }
                    }
                },
                showProgress: false
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenviewNotification, "template", {
        get: function () {
            return "<span class=\"openview-notification__close\">\n                  <span class=\"openview-notification__close-icon\"></span>\n                </span>\n                <div class=\"openview-notification__progress\">\n                    <div class=\"openview-notification__progress-bar\"></div>\n                </div>\n               <div class=\"openview-notification__body\">\n                 {{ image }}\n                 <div class=\"openview-notification__content\">\n                   <div class=\"openview-notification__title\">{{ title }}</div>\n                   <div class=\"openview-notification__desc\">{{ description }}</div>\n                 </div>\n                </div>\n                <div class=\"openview-notification__buttons\">\n                    <span class=\"openview-notification__button openview-notification__button--action\">Ok</span>\n                    <span class=\"openview-notification__button openview-notification__button--cancel\">Cancel</span>\n                </div>";
        },
        enumerable: true,
        configurable: true
    });
    OpenviewNotification.notify = function (options) {
        if (options === void 0) { options = {}; }
        var newInstance = new OpenviewNotification(options).show();
        var reduceHeight = 0;
        var removedNotifications = [];
        var instances = newInstance.position.instances();
        instances.forEach(function (instance) {
            if (OpenviewNotification.hasOverflow(newInstance, reduceHeight)) {
                removedNotifications.push(instance);
                reduceHeight += instance.height() + newInstance.options.margin;
            }
        });
        removedNotifications.forEach(function (instance) {
            instance.remove();
        });
        newInstance.position.calculate();
        return newInstance;
    };
    OpenviewNotification.hasOverflow = function (newInstance, reduceHeight) {
        if (reduceHeight === void 0) { reduceHeight = 0; }
        var result = false;
        var windowHeight = tsdom_1.default.select(window).height();
        var offset = 0;
        if ((newInstance.position instanceof TopCenterPosition_1.TopCenterPosition) ||
            (newInstance.position instanceof TopRightPosition_1.TopRightPosition) ||
            (newInstance.position instanceof TopLeftPosition_1.TopLeftPosition)) {
            offset = (newInstance.getContent().offset().top + newInstance.getContent().height() + newInstance.options.margin) - reduceHeight;
            if (offset >= windowHeight) {
                result = true;
            }
        }
        else if ((newInstance.position instanceof BottomCenterPosition_1.BottomCenterPosition) ||
            (newInstance.position instanceof BottomRightPosition_1.BottomRightPosition) ||
            (newInstance.position instanceof BottomLeftPosition_1.BottomLeftPosition)) {
            offset = newInstance.getContent().offset().top + reduceHeight;
            if (offset <= 0) {
                result = true;
            }
        }
        return result;
    };
    OpenviewNotification.closeAll = function (item) {

        if (OpenviewNotification.instances.indexOf(item) > -1) {
            item.close();
        }else{
            OpenviewNotification.instances = [];
            tsdom_1.default.select('.openview-notification').each(function (openviewNotification) {
                tsdom_1.default.select(openviewNotification).remove();
            });
        }        
    };
    OpenviewNotification.prototype.show = function () {
        this.addNotification();
        this.initPosition();
        this.bindEvents();
        return this;
    };
    OpenviewNotification.prototype.close = function () {
        var self = this;
        this.notification
            .removeClass('animation-' + this.options.animation.open)
            .addClass('animation-' + this.options.animation.close)
            .addClass('openview-notification--closed');
        setTimeout(function () {
            self.remove();
            self.position.calculate();
        }, this.options.animationDuration * 1000);
    };
    OpenviewNotification.prototype.remove = function () {
        var index = OpenviewNotification.instances.indexOf(this);
        OpenviewNotification.instances.splice(index, 1);
        this.notification.remove();
        return this;
    };
    OpenviewNotification.prototype.getContent = function () {
        return this.notification;
    };
    /**
    * Add notification to document
    */
    OpenviewNotification.prototype.addNotification = function () {
        var options = this.options;
        var template = this.template.replace('{{ title }}', options.title);
        template = template.replace('{{ description }}', options.description);
        if (this.options.image.visible) {
            if (this.options.image.customImage) {
                template = template.replace('{{ image }}', '<div class="openview-notification__image openview-notification__image--custom"><img src="' + this.options.image.customImage + '" alt=""></div>');
            }
            else {
                template = template.replace('{{ image }}', '<div class="openview-notification__image"></div>');
            }
        }
        else {
            template = template.replace('{{ image }}', '');
        }
        this.notification
            .addClass('openview-notification')
            .addClass('openview-notification--' + options.type)
            .addClass('animation-' + options.animation.open)
            .addClass('position-' + options.position);
        if (options.image) {
            this.notification.addClass('openview-notification--image');
        }
        this.notification.html(template);
        if (!options.title) {
            this.notification.find('.openview-notification__title').remove();
        }
        if (options.width) {
            this.notification.width(options.width);
        }
        if (options.zIndex) {
            this.notification.css('z-index', options.zIndex);
        }
        if (options.showProgress && (options.closeTimeout > 0)) {
            this.notification
                .find('.openview-notification__progress')
                .addClass('is-visible');
            this.notification.addClass('has-progress');
        }
        if (options.showButtons) {
            this.notification.find('.openview-notification__buttons').addClass('is-visible');
            this.notification.find('.openview-notification__button--action').text(options.buttons.action.text);
            this.notification.find('.openview-notification__button--cancel').text(options.buttons.cancel.text);
        }
        this.body.append(this.notification);
        if (options.showProgress && (options.closeTimeout > 0)) {
            this.calculateProgress();
        }
    };
    /**
    * Calculate and set notification positions
    */
    OpenviewNotification.prototype.initPosition = function () {
        this.position.calculate();
    };
    OpenviewNotification.prototype.calculateProgress = function () {
        var _this = this;
        var intervalAmount = Math.ceil(Number(this.options.closeTimeout) / 100), width = 1, interval = setInterval(function () {
            if (width >= 100) {
                clearInterval(interval);
            }
            else {
                _this.notification
                    .find('.openview-notification__progress-bar')
                    .css('width', width + '%');
                width++;
            }
        }, intervalAmount);
    };
    OpenviewNotification.prototype.bindEvents = function () {
        var self = this;
        if (this.options.closeWith.indexOf('click') > -1) {
            this.notification
                .addClass('openview-notification--close-on-click')
                .on('click', function () { return self.close(); });
        }
        else if (this.options.closeWith.indexOf('button') > -1) {
            var closeBtn = this.notification.find('.openview-notification__close');
            closeBtn.on('click', function () { return self.close(); });
        }
        if (this.options.showButtons) {
            var actionBtn = this.notification.find('.openview-notification__button--action');
            actionBtn.on('click', function (e) {
                self.options.buttons.action.callback.apply(self);
                // Not close on action click
                //self.close();

                setTimeout(function () {
                    OpenviewNotification.instances.forEach(function (instance) {
                        instance.position.calculate();
                    });
                }, 290);

                e.stopPropagation();
                
            });
            var cancelBtn = this.notification.find('.openview-notification__button--cancel');
            cancelBtn.on('click', function (e) {
                self.options.buttons.cancel.callback.apply(self);
                self.close();
                e.stopPropagation();
            });
        }
        if (this.options.closeTimeout && (this.options.closeTimeout > 0)) {
            setTimeout(function () { return self.close(); }, this.options.closeTimeout);
        }
    };
    OpenviewNotification.setGlobalOptions = function (options) {
        OpenviewNotification.globalOptions = options;
    };
    OpenviewNotification.globalOptions = {};
    OpenviewNotification.instances = [];
    return OpenviewNotification;
}());
module.exports = OpenviewNotification;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TopRightPosition_1 = __webpack_require__(1);
var TopCenterPosition_1 = __webpack_require__(2);
var BottomRightPosition_1 = __webpack_require__(3);
var TopLeftPosition_1 = __webpack_require__(4);
var BottomCenterPosition_1 = __webpack_require__(5);
var BottomLeftPosition_1 = __webpack_require__(6);
var PositionFactory = /** @class */ (function () {
    function PositionFactory() {
    }
    PositionFactory.newInstance = function (position, notification, margin) {
        var positionClass = null;
        if (position === TopRightPosition_1.TopRightPosition.position) {
            positionClass = TopRightPosition_1.TopRightPosition;
        }
        else if (position === TopCenterPosition_1.TopCenterPosition.position) {
            positionClass = TopCenterPosition_1.TopCenterPosition;
        }
        else if (position === BottomRightPosition_1.BottomRightPosition.position) {
            positionClass = BottomRightPosition_1.BottomRightPosition;
        }
        else if (position === TopLeftPosition_1.TopLeftPosition.position) {
            positionClass = TopLeftPosition_1.TopLeftPosition;
        }
        else if (position === BottomCenterPosition_1.BottomCenterPosition.position) {
            positionClass = BottomCenterPosition_1.BottomCenterPosition;
        }
        else if (position === BottomLeftPosition_1.BottomLeftPosition.position) {
            positionClass = BottomLeftPosition_1.BottomLeftPosition;
        }
        return new positionClass(notification, margin);
    };
    return PositionFactory;
}());
exports.PositionFactory = PositionFactory;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

return deepmerge_1;

})));


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
});